import { useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import Autocomplete from "components/DesignComponents/Autocomplete";
import TableContext from "context/table/tableContext";
import {
    DROPDOWN_SIZES,
    FALSE,
    Filter,
    FILTER_NAMES,
    filterDropdownCustomWidth,
    TRUE
} from "shared";

import { PERMISSION_DISABLED, PERMISSION_ENABLED } from "./constants";
import { StatusProps } from "./types";

const Status = ({ customStyle }: StatusProps) => {
    const { setInnerTableParams } = useContext(TableContext);

    const { t } = useTranslation();

    const [inputValue, setInputValue] = useState("");

    const handleChange = (newValue: Filter | null) => {
        const paramsPayload = {
            [FILTER_NAMES.Status]: (newValue?.id as string) || []
        };

        const value = newValue ? [newValue] : [];

        const filteredValuesPayload = {
            filterName: FILTER_NAMES.Status,
            value
        };

        setInnerTableParams({
            params: paramsPayload,
            filteredValues: filteredValuesPayload
        });
    };

    return (
        <Autocomplete
            fullWidth
            size={DROPDOWN_SIZES.Small}
            disableClearable
            disableCloseOnSelect
            inputValue={inputValue}
            value={null}
            options={[
                { id: TRUE, name: PERMISSION_ENABLED },
                { id: FALSE, name: PERMISSION_DISABLED }
            ]}
            onInputChange={(_, newInputValue, reason) =>
                reason === "input" && setInputValue(newInputValue)
            }
            onChange={(_, newFilterValue) => handleChange(newFilterValue)}
            onClose={() => setInputValue("")}
            renderValue={() => null}
            textFieldParams={{
                placeholder: t("Filter##permission status")
            }}
            getOptionLabel={(option: Filter) => t(`General##${option.name}`)}
            css={css([filterDropdownCustomWidth, customStyle])}
        />
    );
};

export default Status;
